const ring = 'bc365';
export const environment = {
  production: false,
  envName: ring, // the ring this build was made with (drives the on-screen env indicator)
  //*************urls*************
  apiBaseUrl: 'https://har-docrepo-api-' + ring + '.harrells.com',

  apiScope: 'api://c224bca9-fbf5-48c1-ab76-d75275ae7cfc/user_impersonation',
};
